import { render, staticRenderFns } from "./Masonry.vue?vue&type=template&id=328874c4&"
import script from "./Masonry.vue?vue&type=script&lang=js&"
export * from "./Masonry.vue?vue&type=script&lang=js&"
import style0 from "./Masonry.vue?vue&type=style&index=0&id=328874c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports